import { Model, Survey } from 'survey-react-ui';
import 'survey-core/defaultV2.min.css';
import { useState, Fragment, useEffect } from 'react';
import { Button,Chip } from '@mui/material';
import { dueetheme } from './dueetheme';


function CustomMySurvey({surveymodel}) {

  const [vector,setVector] = useState([0,0,0,0,0,0,0,0,0,0]); // 10 questions
  
  const survey = new Model(surveymodel);

  const [pageNo,setPageNo] = useState(survey.currentPageNo);
  const [isRunning,setIsRunning] = useState(true);

  const [isLastPage,setIsLastPage] = useState(false);
  
  survey.applyTheme(dueetheme);
  
  
  survey.onCurrentPageChanged.add((_,opt)=>{
    setPageNo(opt.newCurrentPage.visibleIndex);
    
    if(opt.newCurrentPage.visibleIndex===survey.visiblePages.length-1){
      survey.setIsLastPage = true;
      setIsLastPage(true);
    }
  });

  survey.onComplete.add(()=>{ 
    console.log("survey complete");
  });

  
  survey.onValueChanged.add((survey, { question, value }) => {
    if(question!==null){
      let indx = Number(question.jsonObj.name);
      vector[indx-1]=value;
    }
  });

  survey.showPrevButton = false;
  survey.showPageNumbers = false;
  survey.showNavigationButtons = false;
  survey.showBrandInfo = false;
  survey.showQuestionNumbers = true;
  
  survey.showProgressBar = false;
  survey.showCompletedPage = true;

  
  const mynextPage = () => {
    if(survey!==undefined){
      if(isLastPage){
        if(survey.isCurrentPageValid){
          setIsRunning(false);
        }
      } else {
        survey.nextPage();
      }
    }
  };

  /* accessibility custom extension */

  const setAnswer = (evnt)=>{
    let questions = document.getElementsByTagName("input");
    if(questions.length>0){
      let k = evnt.key.toLowerCase();
      let answers = {a:0,b:1,c:2};
      if(answers[k]!==undefined){
        questions[answers[k]].click();
      }     
    }
  }
  
  useEffect(() => {
    window.addEventListener("keydown", setAnswer);
    return () => {
      window.removeEventListener("keydown", setAnswer);
    };
  }, []);

  const mybu = ()=>{
    if(!isRunning) {
      return (<span></span>);
    }
    else {
    return(<div style={{textAlign:'center'}}>
            <Button accessKey='n' sx={{marginLeft:'0',bgcolor:'#0060e6',fontFamily:'Barlow'}} onClick={()=>{
              mynextPage();
            }} variant="contained">{!isLastPage?"Avanti":"Invio"}</Button>
          </div>);
    }
  }

  const results = ()=>{
    const val = vector.reduce( (a,b)=> a+b, 0);
    //setSums(val);
    if((val>20)&&(val<36)){
      return(
        <div style={{textAlign:'center'}}><h2 style={{fontFamily:'Barlow'}}>Hai totalizzato {val} punti</h2>
          <img className={'survey-result-img'}  alt='Consumatore consapevole' src='./images/risultato2.jpg'/>
          <p style={{fontFamily:'Barlow'}}><strong>Hai delle buone abitudini, ma puoi migliorare!</strong></p>
          <p style={{fontFamily:'Barlow'}}>Prova a comprare meno e optare per capi di seconda mano o riparazioni per ridurre ancora di più il tuo impatto.</p>
        </div>
      );
    }
    if(val>35){
      return(
        <div style={{textAlign:'center'}}><h2 style={{fontFamily:'Barlow'}}>Hai totalizzato {val} punti</h2>
        <img className={'survey-result-img'}  alt='Energy waster' src='./images/risultato3.jpg'/>
        <p style={{fontFamily:'Barlow'}}><strong>Il tuo guardaroba è un grande spreco di energia!</strong></p>
        <p style={{fontFamily:'Barlow'}}>Ma puoi cambiare: inizia comprando meno, donando i vestiti che non usi più e lavando in modo più sostenibile.</p>
        </div>
      );
    }
    if((val>9)&&(val<21)){
      return(
      <div style={{textAlign:'center'}}><h2 style={{fontFamily:'Barlow'}}>Hai totalizzato {val} punti</h2>
        <img className={'survey-result-img'} alt='Green shopper' src='./images/risultato1.jpg'/>
        <p  style={{fontFamily:'Barlow'}}><strong>Complimenti!</strong></p>
        <p  style={{fontFamily:'Barlow'}}>Fai scelte consapevoli e il tuo impatto energetico è ridotto.</p>
        <p  style={{fontFamily:'Barlow'}}>Continua così e ispira gli altri a seguire il tuo esempio!</p>
      </div>);
    }
    return(<div style={{textAlign:'center'}}><h2 style={{fontFamily:'Barlow'}}>Hai totalizzato {val} punti</h2></div>);
  }
  
  return (
        <Fragment>
          {!isRunning && results()}
          {isRunning && (<Survey currentPageNo={pageNo} model={survey}/>)}
          {mybu()}
        </Fragment>
  );
}

export default CustomMySurvey;
